// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33aY_","type":"styles_type__3apds","choices":"styles_choices__3TfyR"};